import React from 'react';
import { Row as AntRow } from 'antd';

/**
 * Wrapper component for Ant Design Row
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Row functionality including gutter, align, and justify options.
 * 
 * @component
 * @example
 * import { Row, Col } from '../GeneralComponents/ui';
 * 
 * <Row gutter={16}>
 *   <Col span={12}>col-12</Col>
 *   <Col span={12}>col-12</Col>
 * </Row>
 * 
 * <Row gutter={[16, 24]}>
 *   <Col span={8}>col-8</Col>
 *   <Col span={8}>col-8</Col>
 *   <Col span={8}>col-8</Col>
 * </Row>
 * 
 * @see https://ant.design/components/grid/ - Ant Design Grid documentation
 */
const Row = (props) => {
  return <AntRow {...props} />;
};

export default Row;

